'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _resetPassword = require('./reset-password.service');

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _resetPassword3 = require('./reset-password.component');

var _resetPassword4 = _interopRequireDefault(_resetPassword3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.auth.resetPassword', [_angularUiRouter2.default]).component('resetPassword', _resetPassword4.default).service('ResetPasswordService', _resetPassword2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('resetPassword', {
    parent: 'auth',
    url: '/reset-password',
    params: {
      userName: null
    },
    component: 'resetPassword',
    resolve: {
      layout: function layout() {
        return 'column';
      },
      flex: function flex() {
        return '100';
      },
      credentials: function credentials($stateParams) {
        return {
          UserName: $stateParams.userName
        };
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/auth/reset-password/reset-password.module.js